import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDisplayComponent } from './file-display.component';
import { MatIconModule } from "@angular/material/icon";



@NgModule({
  declarations: [
    FileDisplayComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
]
})
export class FileDisplayModule { }
